import { SelectColumn } from "react-data-grid";
import { Tooltip } from "components/Tooltip/Tooltip";

// Select column for Invoice List report.
// Allows selecting Draft invoices (for posting) and Finalized invoices (for voiding).
// Only Paid and Voided invoices are blocked.
export const InvoiceBatchSelectColumn = {
  ...SelectColumn,
  renderCell: (props: Parameters<typeof SelectColumn.renderCell>[0]) => {
    const { row } = props;

    const invoiceRow = row as Record<string, unknown>;
    const status = String(invoiceRow.Status || "").toLowerCase();
    const paymentStatus = String(
      invoiceRow["Payment Status"] || "",
    ).toLowerCase();

    const validForPosting = String(
      invoiceRow["Valid for Posting"] || "",
    ).toLowerCase();

    const selectable =
      paymentStatus !== "paid" &&
      ((status === "draft" && validForPosting === "yes") ||
        status === "finalized");

    const getDisabledReason = () => {
      if (paymentStatus === "paid") {
        return "Already Paid: This invoice has been paid and cannot be modified";
      }
      if (status === "voided") {
        return "Voided: This invoice has already been voided";
      }
      if (status === "draft" && validForPosting !== "yes") {
        return "Not Valid for Posting: This invoice is missing required information";
      }
      return "Not Eligible: This invoice cannot be selected";
    };

    if (!selectable) {
      const originalCheckbox = SelectColumn.renderCell(props);

      return (
        <Tooltip
          content={getDisabledReason()}
          place="top"
          anchorStyle="block-full"
        >
          <div className="conditional-select-cell not-selectable">
            <div className="checkbox-wrapper disabled">{originalCheckbox}</div>
          </div>
        </Tooltip>
      );
    }

    return SelectColumn.renderCell(props);
  },
};

// select column for Section 111 Invoicing report
// allows selecting already-invoiced rows but shows a warning tooltip
export const Section111SelectColumn = {
  ...SelectColumn,
  renderCell: (props: Parameters<typeof SelectColumn.renderCell>[0]) => {
    const { row } = props;
    const detailRow = row as Record<string, unknown>;
    const invoiced = String(
      detailRow["Previously Invoiced"] || detailRow.Invoiced || "",
    ).toLowerCase();

    if (invoiced === "yes") {
      return SelectColumn.renderCell(props);
    }

    return SelectColumn.renderCell(props);
  },
};
